export const messages = {
  error_message : 'Something went wrong!, Please try again',
  api_failed_msg : 'Unable to fetch data. Please try again',
  error_no_sol : 'Unable to fetch Solutions. Please try again',
  error_no_user_detail : 'Unable to fetch User Detail. Please try again',
  error_no_area : 'Unable to fetch Area. Please try again',
  error_create : 'Unable to Create Solution. Please try again'
};
